
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/contest",
      function () {
        return require("private-next-pages/dashboard/contest.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/contest"])
      });
    }
  